export default __webpack_public_path__ + "static/media/error-icon.41871cc0.svg";